import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { fetchUserProfile } from '../../services/api';
import SideNav from './SideNav';

const Dashboard = () => {
    const location = useLocation();
    const [userProfile, setUserProfile] = useState(null);
    const [error, setError] = useState(null);
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();

    useEffect(() => {
        const loadProfile = async () => {
            try {
                const profileData = await fetchUserProfile(token);
                setUserProfile(profileData);
            } catch (err) {
                setError(err.detail || 'Error fetching user profile');
                console.error('Error fetching user profile:', err);
            }
        };
        loadProfile();
    }, [token]);

    const handleLogout = () => {
        navigate('/logout');
    };

    const getClassName = () => {
        return location.pathname === '/birthdays' ? 'body-birthdays' : '';
    };

    return (
        <div className='dashboard-background'>
            <div className={`container-fluid ${getClassName()}`}>
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <div className="row">
                    <SideNav userProfile={userProfile} handleLogout={handleLogout} />

                    <main className="col-md-9 ms-sm-auto col-lg-10 px-4 d-flex flex-column mt-3" style={{ minHeight: '100vh' }}>
                        <div className="text-center mb-4 d-flex align-items-center justify-content-center">
                            <img
                                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747769920/logo_oq3zwy.png"
                                alt="Logo"
                                style={{ width: '50px', height: '50px', marginRight: '10px' }}
                            />
                            <h1 className="d-inline mb-0 fw-bold">Digis Customer Portal</h1>
                        </div>

                        {location.pathname === '/dashboard' && (
                            <div className="container">
                                <div className="row mb-4">
                                    {/* Top Left: Welcome Text */}
                                    <div className="col-md-6 d-flex flex-column justify-content-center">
                                        <h1 className="mb-3 fw-bold">Welcome to Digis, {userProfile?.username}!</h1>
                                        <h6 className="fw-bold mt-3">
                                            Explore top talent, stay on top of project progress, and make the most of your Digis experience.
                                        </h6>
                                    </div>

                                    {/* Top Right: Image */}
                                    <div className="col-md-6 text-center mb-5">
                                        <img
                                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747770711/image_oh9iog.png"
                                            alt="Welcome"
                                            className="img-fluid"
                                            style={{ maxWidth: '100%', height: 'auto' }}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    {/* Bottom Left: Outsource Requests */}
                                    <div className="col-md-6 mb-4">
                                        <Link to="/project" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div className="p-4 border border-dark rounded h-100 hover-card"
                                            style={{
                                            boxShadow: '0 1rem 2rem rgba(0, 0, 0, 0.6)'
                                                }}>
                                                <h4 className="fw-bold text-center">Product Development</h4>
                                                <p className="fw-bold text-center">Track your project development through 8 comprehensive stages</p>
                                                <img
                                                    src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747595008/Pie_Chart_Example_drl33e.png" // Replace with your pie chart image
                                                    alt="Progress Pie"
                                                    className="img-fluid mb-2"
                                                    style={{ width: '100%', maxWidth: '450px', height: '300px', objectFit: 'contain', display: 'block', margin: '0 auto' }}
                                                />
                                                <ul className="list-unstyled">
                                                    <li className="mb-2 d-flex justify-content-center align-items-start">
                                                        <span className="me-2 text-success">📊</span>
                                                        <span>Real-time project progress tracking</span>
                                                    </li>
                                                    <li className="mb-2 d-flex justify-content-center align-items-start">
                                                        <span className="me-2 text-success">📊</span>
                                                        <span>8-stage development process</span>
                                                    </li>
                                                    <li className="mb-2 d-flex justify-content-center align-items-start">
                                                        <span className="me-2 text-success">📊</span>
                                                        <span>Document management &amp; NDA handling</span>
                                                    </li>
                                                </ul>

                                            </div>
                                        </Link>
                                    </div>

                                    {/* Bottom Right: Outstaff Requests */}
                                    <div className="col-md-6 mb-4">
                                        <Link to="/outstaff" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div className="p-4 border border-dark rounded h-100 hover-card"
                                            style={{
                                            boxShadow: '0 1rem 2rem rgba(0, 0, 0, 0.6)'
                                               }}>
                                                <h4 className="fw-bold text-center">Outstaff Recruitment</h4>
                                                <p className="fw-bold text-center">Manage your specialist hiring through our candidate pipeline</p>
                                                <img
                                                    src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747668688/pipeline_ob0cw9.png" // Replace with your kanban image
                                                    alt="Candidate Pipeline"
                                                    className="img-fluid mb-2"
                                                    style={{ width: '100%', maxWidth: '450px', height: '300px', objectFit: 'contain', display: 'block', margin: '0 auto' }}
                                                />
                                                <ul className="list-unstyled">
                                                    <li className="mb-2 d-flex justify-content-center align-items-start">
                                                        <span className="me-2 text-primary">✔️</span>
                                                        <span>Job brief creation &amp; management</span>
                                                    </li>
                                                    <li className="mb-2 d-flex justify-content-center align-items-start">
                                                        <span className="me-2 text-primary">✔️</span>
                                                        <span>Browse qualified candidates</span>
                                                    </li>
                                                    <li className="mb-2 d-flex justify-content-center align-items-start">
                                                        <span className="me-2 text-primary">✔️</span>
                                                        <span>Drag-and-drop pipeline management</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}

                        <Outlet context={{ userProfile, handleLogout }} />
                    </main>
                </div>
            </div>

        </div>
    );
};

export default Dashboard;
